import { useState } from "react";
import { FileSpreadsheet, FileText, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { exportGeneric } from "@/lib/toolExport";

export const ExportButtons = ({ buildPayload }) => {
  const [busy, setBusy] = useState(null);
  const run = async (kind) => {
    setBusy(kind);
    try {
      await exportGeneric(kind, buildPayload());
      toast.success(`${kind === "excel" ? "Excel" : "PDF"} downloaded`);
    } catch {
      toast.error("Could not generate the report.");
    } finally {
      setBusy(null);
    }
  };
  return (
    <div className="flex flex-col sm:flex-row gap-3" data-testid="tool-export-bar">
      <Button data-testid="tool-export-excel" onClick={() => run("excel")} disabled={busy} variant="outline"
        className="flex-1 h-11 rounded-xl border-[#2D6A4F]/30 bg-white text-[#2D6A4F] hover:bg-[#2D6A4F]/5 font-semibold">
        {busy === "excel" ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : <FileSpreadsheet className="h-4 w-4 mr-2" />}
        Export Excel
      </Button>
      <Button data-testid="tool-export-pdf" onClick={() => run("pdf")} disabled={busy} variant="outline"
        className="flex-1 h-11 rounded-xl border-[#D96B43]/30 bg-white text-[#D96B43] hover:bg-[#D96B43]/5 font-semibold">
        {busy === "pdf" ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : <FileText className="h-4 w-4 mr-2" />}
        Export PDF
      </Button>
    </div>
  );
};
